import type { ReactNode } from 'react'
import listStyles from '@/styles/pages/governance/GovernanceListing.module.scss'

export type MetricTone = 'yellow' | 'blue' | 'green' | 'red' | 'purple' | 'orange' | 'neutral'

const TONE_CLASS: Record<MetricTone, string> = {
  yellow: listStyles.metricTileYellow,
  blue: listStyles.metricTileBlue,
  green: listStyles.metricTileGreen,
  red: listStyles.metricTileRed,
  purple: listStyles.metricTilePurple,
  orange: listStyles.metricTileOrange,
  neutral: '',
}

type Props = {
  label: ReactNode
  value: ReactNode
  tone?: MetricTone
  title?: string
}

export function ComplianceCenterMetricTile({ label, value, tone = 'blue', title }: Props) {
  return (
    <div className={`${listStyles.metricTile} ${TONE_CLASS[tone]}`.trim()} title={title}>
      <p className={listStyles.metricTileLabel}>{label}</p>
      <p className={listStyles.metricTileValue}>{value}</p>
    </div>
  )
}
